<template>
  <v-row class="pa-4">
    <v-col cols="12" xs="12" class="pt-0 py-0">
      <span class="headline">Mediathek bearbeiten</span>
    </v-col>
    <v-col cols="12" xs="12" class="pa-4">
      <v-btn @click="editMediaTheke(true)" color="primary" class="mr-2">Querformat</v-btn>
      <v-btn @click="editMediaTheke(false)" color="primary">Hochformat</v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Mediatheke',
  components: {},
  data () {
    return {
    }
  },
  methods: {
    editMediaTheke: function(isQuer) {
      if (isQuer) {
        this.$router.push('/Playlist/GlobalMediathekH')
      } else {
        this.$router.push('/Playlist/GlobalMediathekV')
      }

    }
  },
  mounted () {
    //Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>
